import { Tag } from 'lib-shared-legacy-types';

import { ajaxSend } from 'api/api';

const v1BasePath = '/v1/tags';
const v2BasePath = '/v2/tags';

export type ActiveState = 'active' | 'inactive' | null;

export interface TagsQueryParams {
  search?: string;
  offset?: number;
  limit?: number;
  sort_by?: string;
  active_state?: ActiveState;
}

export interface TagsGetItemsResponse {
  data: {
    tags: Array<Tag>;
  };
  meta: {
    next_page: string | null;
    prev_page: string | null;
  };
}

export interface TagsGetItemResponse {
  data: Tag;
  meta: {};
}

export function getTags(params: TagsQueryParams = {}) {
  return ajaxSend<TagsGetItemsResponse>({
    path: `${v2BasePath}/conversation`,
    params: params as any,
  });
}

export function getTagsByName(tagIds: Array<string>) {
  const request = {
    path: `${v2BasePath}/conversation?names=${tagIds.join()}`,
  };

  return ajaxSend<TagsGetItemsResponse>(request);
}

export function removeTag(tagId: string) {
  return ajaxSend<TagsGetItemResponse>({
    method: 'DELETE',
    path: `${v1BasePath}/conversation/${tagId}`,
  });
}

export function createTag(tag: Pick<Tag, 'name' | 'color'>) {
  const { name, color } = tag;

  return ajaxSend<TagsGetItemResponse>({
    method: 'POST',
    path: `${v1BasePath}/conversation`,
    data: {
      name: name,
      color: color,
    },
  });
}

export function activateTag(tagId: string): Promise<TagsGetItemResponse> {
  return ajaxSend({
    method: 'PATCH',
    path: `${v1BasePath}/${tagId}/activate`,
  });
}

export function deactivateTag(tagId: string): Promise<TagsGetItemResponse> {
  return ajaxSend({
    method: 'PATCH',
    path: `${v1BasePath}/${tagId}/deactivate`,
  });
}
